import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { BlockSection } from "@/react/components/shared/BuilderUI/BlockSection";
import { useTopBlockStyles } from "@circle-react-shared/BuilderUI/Hooks/useTopBlockStyles";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { primaryBlockDefaultStyles } from "../../constants";

export interface HomepageBlock4Props extends ComponentPropsWithRef<"div"> {
  header?: ReactNode;
  leftContent?: ReactNode;
  rightContent?: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const HomepageBlock4 = forwardRef<HTMLDivElement, HomepageBlock4Props>(
  ({ header, leftContent, rightContent, styles, className, ...rest }, ref) => {
    const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles(
      {
        styles,
        defaultStyles: primaryBlockDefaultStyles,
      },
    );

    return (
      <BlockSection ref={ref} className={className} {...rest}>
        <BlockSection.Background style={backgroundStyles}>
          <BlockSection.Container>
            <BlockSection.Content
              style={{
                ...paddingStyles,
                ...marginStyles,
              }}
            >
              <BlockSection.NestedBlock className="wb-mx-auto wb-flex wb-max-w-3xl wb-flex-col wb-items-center wb-gap-4 wb-text-center md:wb-gap-6">
                {header}
              </BlockSection.NestedBlock>
              <div className="wb-flex wb-flex-col wb-gap-10 md:wb-grid md:wb-grid-cols-2 md:wb-gap-16">
                <BlockSection.NestedBlock className="wb-flex wb-flex-col wb-gap-4 md:wb-gap-8">
                  {leftContent}
                </BlockSection.NestedBlock>
                <BlockSection.NestedBlock className="wb-mx-auto">
                  {rightContent}
                </BlockSection.NestedBlock>
              </div>
            </BlockSection.Content>
          </BlockSection.Container>
        </BlockSection.Background>
      </BlockSection>
    );
  },
);

HomepageBlock4.displayName = "HomepageBlock4";
